import { ReactNode } from 'react';

import SettingsPresentComponentMenu from 'approot/activity-builder/settings/present/settings-present-component-menu';
import TTSMenuItem from './tts-menu-item';

type Props = {
  componentId: string;
  componentType: string;
  isActive: boolean;
  children: ReactNode;
};

const TTSComponentMenu = ({
  componentId,
  componentType,
  isActive,
  children,
}: Props) => (
  <SettingsPresentComponentMenu
    isActive={isActive}
    menuItems={
      <TTSMenuItem componentId={componentId} componentType={componentType} />
    }
  >
    {children}
  </SettingsPresentComponentMenu>
);

export default TTSComponentMenu;
